<template>
  <div class="all">
    <div class="all_top">
      <span>办公物资采购系统   Office Material Purchasing System</span>
      <div class="all_top_right">
        联系我们
        <div class="all_top_Tishi">
          <p>集团客服</p>
          <p>400-700-2248</p>
        </div>
      </div>
    </div>
    <el-row>
      <el-col :span="4">
        <!--        左边-->
        <div class="all_left">
          <div class="all_left_img">
            <img :src="$store.state.Url+datalist.image" alt="">
          </div>
          <div class="all_left_p">
<!--            <p>彩色公司</p>-->
<!--            <p>客服部</p>-->
            <p>{{datalist.real_name}}</p>
          </div>
          <div>
            <el-row class="tac">
              <el-col :span="24">
                <el-menu
                  default-active="2"
                  class="el-menu-vertical-demo"
                  @open="handleOpen"
                  @close="handleClose"
                  text-color="#fff"
                  active-text-color="#ff9049"
                >
                  <el-submenu index="1">
                    <template slot="title">
                      <i class="el-icon-s-goods"></i>
                      <span>购买商品</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="1-1" @click="personTab = 0">收藏商品</el-menu-item>
                      <el-menu-item index="1-2" @click="personTab = 2">我的足迹</el-menu-item>
                      <el-menu-item index="1-3" @click="$router.push({path:'/ShoppingCart'})">购物车</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="2">
                    <template slot="title">
                      <i class="el-icon-s-order"></i>
                      <span>订单管理</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="2-1" @click="personTab = 1">订单查询</el-menu-item>
                      <!--                      <el-menu-item index="2-2">选项2</el-menu-item>-->
                    </el-menu-item-group>
                  </el-submenu>
                <!--  <el-submenu index="3">
                    <template slot="title">
                      <i class="el-icon-notebook-1"></i>
                      <span>会计管理</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="3-1" @click="personTab = 2">会计管理</el-menu-item>
                      &lt;!&ndash;                      <el-menu-item index="3-2">选项2</el-menu-item>&ndash;&gt;
                    </el-menu-item-group>
                  </el-submenu>-->
                  <el-submenu index="4">
                    <template slot="title">
                      <i class="el-icon-setting"></i>
                      <span>系统设置</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="4-1" @click="personTab = 3">个人资料</el-menu-item>
                      <el-menu-item index="4-8" @click="personTab = 8">申请月结</el-menu-item>
                      <el-menu-item index="4-6" @click="personTab = 7">留言列表</el-menu-item>
                      <el-menu-item index="4-2" @click="personTab = 4">我的积分</el-menu-item>
                      <el-menu-item index="4-3" @click="personTab = 5">积分兑换</el-menu-item>
                      <el-menu-item index="4-4" @click="personTab = 6">地址管理</el-menu-item>
                      <el-menu-item index="4-5" @click="getDel">退出登录</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <!--        右边-->
        <div class="all_right">
          <div style="width: 100%;height: 60px"></div>
          <div class="all_right_all">
            <!--            收藏商品-->
            <focusoncommodities v-if="personTab == 0"></focusoncommodities>
            <!--            收藏商品-->
            <zuji v-if="personTab == 2"></zuji>
            <!--            个人信息-->
            <personalinformation v-if="personTab == 3"></personalinformation>
            <!--            订单管理-->
            <Order v-if="personTab == 1"></Order>
            <!--            积分兑换-->
            <IntegralExchange v-if="personTab == 5"></IntegralExchange>
            <!--            我的积分-->
            <MyPoints @type="getType" v-if="personTab == 4"></MyPoints>
            <!--            地址管理-->
            <MyAds v-if="personTab == 6"></MyAds>
            <!--            留言列表-->
            <Liuyan v-if="personTab == 7"></Liuyan>
            <!--            申请月结-->
            <yuejie v-if="personTab == 8"></yuejie>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import focusoncommodities from "./focusoncommodities";
  import personalinformation from "./personalinformation";
  import Order from "./Order";
  import Liuyan from "./Liuyan";
  import IntegralExchange from "./IntegralExchange";
  import MyPoints from "./MyPoints";
  import MyAds from "./MyAds";
  import zuji from "./zuji";
  import yuejie from "./yuejie";

  export default {
    name: "personalCenter",
    components: {
      focusoncommodities,personalinformation,Order,IntegralExchange,MyPoints,MyAds,zuji,yuejie,Liuyan
    },
    data(){
      return{
        personTab:1,
        datalist:{}
      }
    },
    mounted() {
      this.datalist = JSON.parse(localStorage.getItem('user'))
      if (this.$route.query.page){
        this.personTab = this.$route.query.page
      }
    },
    methods: {
      //左边
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      getType(e){
        this.personTab = e
      },
      getDel(){
        this.$store.dispatch('FedLogOut').then(res=>{
          this.$router.push('/')
        })
      }
    }
  }
</script>

<style scoped lang="less">
  @import "css/personalCenter";
  .el-row {
    width: 100% !important;
    height: 100% !important;
  }
  .all{
    width: 100%;
    height: 100%;
  }
</style>
<style>


  .el-col-4 {
    height: 100% !important;
  }

  .el-col-20 {
    height: 100% !important;
  }

  .el-menu {
    background: transparent !important;
  }

  .el-submenu__title:focus, .el-submenu__title:hover {
    outline: 0 !important;
    color: #ff4500 !important;
    background: rgba(0, 0, 0, .3) !important;
  }

  .el-menu-item:hover {
    outline: 0 !important;
    color: #ff4500 !important;
    background: rgba(0, 0, 0, .3) !important;
  }

  .el-menu-item.is-active {
    color: #ff4500 !important;
    background: rgba(0, 0, 0, .2) !important;
  }

  .el-menu {
    border-right: 1px solid #3a3a3a !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalCenter.vue